/**
 * Stable pseudonymous surrogate for GA4 `user_id`, GTM, and Clarity identify.
 * Does not replace legal review; raw patient identifiers must not be sent to vendors.
 */
export async function hashUserIdForAnalytics(userId: string): Promise<string> {
  const enc = new TextEncoder().encode(userId);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
